@import '@hevoio/hevo-ui-toolkit/styles/variables';
@import '@hevoio/hevo-ui-toolkit/styles/typography/typography-utils';

@import 'variables';

.container {
  display: flex;
  height: 100%;
}

.configContainer {
  flex: 3;
  height: 100%;
  overflow: auto;
  padding: $spacer * 2 $spacer * 1.25;
  display: flex;
  justify-content: center;
  position: relative;

  .configFromWrapper {
    width: 85%;

    .header {
      @include typography-level-to-styles(typography-config(), title-3);
      color: $text-default;
      margin-bottom: $spacer * 0.5;
    }

    .subHeader {
      @include typography-level-to-styles(typography-config(), body-1);
      color: $text-secondary;
      margin-bottom: $spacer * 2.5;
    }

    .backdrop {
      position: relative;
    }

    .backdrop::after {
      content: ' ';
      background: $surface-bg-60;
      position: absolute;
      height: 100%;
      width: 100%;
      padding: $spacer * 0.65 0px;
      top: 0;
      left: 0;
      z-index: 4;
    }

    .formWrapper {
      padding-bottom: $spacer * 3;

      .inputSubSection {
        padding: $spacer * 1.25;
        border: $border-width solid $divider-color;
        border-radius: $border-radius-md;
        margin-bottom: $spacer * 2;

        .sectionHeader {
          @include typography-level-to-styles(typography-config(), body-3);
          margin-bottom: $spacer * 2;
        }

        .radioSection {
          margin: $spacer * 1.75 0;
          display: flex;
          align-items: center;
          gap: $spacer * 2.5;

          .radioLabel {
            margin-left: $spacer * 0.75;
            @include typography-level-to-styles(typography-config(), body-2);
          }
        }
      }

      .fixedFooterWrapper {
        position: fixed;
        bottom: 0;
        left: $appbar-width;
        width: calc(100% - 84px);
        display: flex;

        .buttonsWrapper {
          display: flex;
          justify-content: center;
          gap: $spacer * 0.625;
          flex: 3;
          padding: $spacer * 1.25;
          transition: opacity 0.2s ease;
          background: linear-gradient(to top, $surface-bg, $surface-bg 80%, $surface-bg-0);
        }

        .dummyFixedFooterComponent {
          flex: 2;
        }
      }

      .fixedFooterWrapperEdit {
        left: 0;
        width: 100%;
      }
    }
  }

  .goBackButton {
    position: absolute;
    top: 20px;
    left: 20px;
    color: $text-default;
  }
}

.inviteMemberModalContainer {
  padding: $spacer * 1.5;
  width: 600px;
  position: relative;

  .iconWrapper {
    display: flex;
    justify-content: center;
    margin-bottom: $spacer * 1.25;
  }

  .closeIcon {
    position: absolute;
    top: $spacer;
    right: $spacer;
    cursor: pointer;
  }

  .copyIcon {
    z-index: 2;
  }

  .textInputWrapper {
    margin-top: $spacer * 2.5;
    margin-bottom: $spacer * 1.25;
  }

  .checkboxLabel {
    color: $text-default;
  }

  .copyTextWrapper {
    border: solid $border-width $default-border;
    padding: $spacer;
    position: relative;
    margin-top: $spacer * 1.25;
    border-radius: $border-radius-md;
    line-height: $line-height-body;

    .copyIcon {
      position: absolute;
      top: $spacer;
      right: $spacer;
      cursor: pointer;
    }
  }

  .copyHelperText {
    color: $text-secondary;
  }

  .shareButtonSection {
    margin-top: $spacer * 2;
    display: flex;
    justify-content: center;
  }
}

.setupGuideDocs {
  flex: 2;
}
